import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card } from '@novaquantis/design-system';
import { formatPageTitle } from '@shared/browserMeta';
import BrandMark from '../components/BrandMark';
import { APP_PAGE_TITLE_PREFIX } from '../useAppRoutePageTitle';

const NotFoundPage = () => {
  useEffect(() => {
    document.title = formatPageTitle(APP_PAGE_TITLE_PREFIX, 'Page Not Found');
  }, []);

  return (
    <div className="flex flex-1 items-center justify-center px-6 py-8">
      <Card className="flex w-full max-w-[420px] flex-col items-center gap-3 text-center">
        <BrandMark wordmarkSize={24} />
        <h1 className="m-0 font-display text-xl font-bold text-foreground">Page not found</h1>
        <p className="m-0 text-sm leading-normal text-muted-foreground">
          The page you are looking for does not exist or may have been moved.
        </p>
        <Link to="/" className="no-underline">
          <Button variant="glow">Go home</Button>
        </Link>
      </Card>
    </div>
  );
};

export default NotFoundPage;
